module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('section', {
    staticClass: "panel panel-about"
  }, [_c('header', {
    staticClass: "panel-heading"
  }, [_c('h1', {
    staticClass: "panel-title"
  }, [_vm._v("About Colin")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('p', [_vm._v("Boulder based, Cincinnati sourced. Left-handed excellence since 1983.")]), _vm._v(" "), _c('ul', {
    staticClass: "icon-group"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/ColinJosephStevenson",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Facebook")]), _vm._v(" "), _c('span', {
    staticClass: "icon-facebook"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.linkedin.com/in/colinjstevenson",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("LinkedIn")]), _vm._v(" "), _c('span', {
    staticClass: "icon-linkedin"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.instagram.com/cojsteve/",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Instagram")]), _vm._v(" "), _c('span', {
    staticClass: "icon-instagram"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.flickr.com/photos/colinstevenson/",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Flickr")]), _vm._v(" "), _c('span', {
    staticClass: "icon-flickr"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/colinStevenson",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Github")]), _vm._v(" "), _c('span', {
    staticClass: "icon-github"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://twitter.com/cojsteve",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Twitter")]), _vm._v(" "), _c('span', {
    staticClass: "icon-twitter"
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-28220a03!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/routes/About.vue
// module id = 118
// module chunks = 2